import React from 'react';
import { observable } from "mobx";
import { Table, Label } from 'reactstrap';
import { Link } from "react-router-dom";
import moment from 'moment';
import lscache from "lscache";

let dataConsulta;
let dataAgenda = {};
let horaAgenda = {};

const dataAgendamento = (data) => {
    dataAgenda = {
        label: `${moment(data).format("ddd")} - ${moment(data).format("DD/MM/YYYY")}`,
        value: `${moment(data).format("YYYY-MM-DD")}T00:00:00`
    }
    return dataAgenda;
}

const horaAgendamento = (hora) => {
    horaAgenda = {
        AgendGold: "N",
        label: {},
        value: hora
    }
    return horaAgenda;
}

const isLogado = () => lscache.get('access_token')

const gerarLink = (valor,
    path,
    getTipoAgendaIdFromFainaId,
    tipoAgendamento,
    tipoFainaId,
    voltar,
    dataAgendamento,
    dataConsulta,
    horaAgendamento,
    hora,
    setHoraDashboard,
    setModalOpcoes,
    opcoesModal) => {

    const linkGerado = <Link to={{
        pathname: path,
        state: {
            dados: getTipoAgendaIdFromFainaId(tipoAgendamento, tipoFainaId.value),
            voltar: voltar,
            data: dataAgendamento(dataConsulta),
            hora: horaAgendamento(hora),
            faina: tipoFainaId
        }
    }}
    >
        {valor}
    </Link>

    const linkModalOpcoes = <Link to="#" onClick={() => { setHoraDashboard(hora); setModalOpcoes(opcoesModal); }}>{valor}</Link>
    return !opcoesModal ? linkGerado : linkModalOpcoes;
}

const horaHabilitada = (dataAtual,
    dataLimite,
    capacidade,
    hora,
    listaHorasCapacidade) => {
    let habilitado = false;

    habilitado = ((dataAtual >= dataLimite) && (capacidade > 0) && listaHorasCapacidade.includes(hora));

    return habilitado;
}

const linhaCapacidade = (capacidade,
    dataConsulta,
    hora,
    setHoraDashboard,
    tipoAgendamento,
    tipoFainaId,
    getTipoAgendaIdFromFainaId,
    dataAgendamento,
    horaAgendamento,
    horaLimite,
    listaHorasCapacidade,
    setModalOpcoes,
    opcoesModal,
    agendados,
    controller) => {

    const horaAtual = moment().format("HH");
    const dataAtual = moment(`${dataConsulta} ${hora}:00`).format("YYYY-MM-DD HH:mm");
    const dataLimite = moment(`${dataConsulta} ${horaLimite}:00`).format("YYYY-MM-DD HH:mm");
    const habilitado = ((dataAtual >= dataLimite) &&
        (capacidade > 0) &&
        (agendados > 0 ? (capacidade - agendados) > 0 : true) &&
        (listaHorasCapacidade.includes(hora))
        && isLogado()
        && controller.can("I", "AgendamentoContainer")
    );

    return <td key={hora} style={{ textDecorationLine: `${habilitado ? 'underline' : 'none'}` }}>
        {habilitado ?
            capacidade ?
                gerarLink(capacidade,
                    'agendamento-container/cadastro',
                    getTipoAgendaIdFromFainaId,
                    tipoAgendamento,
                    tipoFainaId,
                    '/agendamento-dashboard',
                    dataAgendamento,
                    dataConsulta,
                    horaAgendamento,
                    hora,
                    setHoraDashboard,
                    setModalOpcoes,
                    opcoesModal)
                : 0
            :
            capacidade ?
                capacidade
                : 0
        }
    </td>
}

const printZeroCells = () => new Array(24).fill(0).map((value, index) => { return <td key={index}>{value}</td> })
const printHeadersHours = () => [...new Array(24).keys()].map((linha, index) => <th key={index}>{linha}</th>)

export const ListaGeral = (props) => {
    dataConsulta = props.dataConsulta;
    return (
        <div className="filtros">
            <br /><br />
            <Table responsive hover striped bordered>

                <thead className="destaque">
                    <tr>
                        <td colSpan="25"><b>{`${props.tipoFaina} - ${moment(props.dataConsultaTitulo).format("DD/MM/YYYY")}`}</b></td>
                    </tr>
                    <tr>
                        <th></th>
                        {printHeadersHours()}
                    </tr>
                </thead>
                <tbody className="destaque">
                    <tr>
                        <th scope="row">Capacidade</th>
                        {props.lista && props.lista.capacidade.map((capacidade, index) => {
                            return linhaCapacidade(capacidade,
                                dataConsulta,
                                index,
                                props.setHoraDashboard,
                                props.tipoAgendamento,
                                props.tipoFainaId,
                                props.getTipoAgendaIdFromFainaId,
                                dataAgendamento,
                                horaAgendamento,
                                props.horaLimite,
                                props.listaHorasCapacidade,
                                props.setModalOpcoes,
                                props.opcoesModal,
                                props.lista.agendados[index],
                                props.controller)
                        })
                        }
                    </tr>
                    <tr>
                        <th scope="row">Atendidos</th>
                        {props.lista && props.lista.atendidos && props.lista.atendidos.length > 0 ?
                            props.lista.atendidos.map((atendido, index) => {
                                return <td key={index}>{atendido ? atendido : 0}</td>
                            })
                            :
                            printZeroCells()
                        }
                    </tr>
                    <tr>
                        <th scope="row">Agendados</th>
                        {props.lista && props.lista.agendados && props.lista.agendados.length > 0 ?
                            props.lista.agendados.map((agendado, index) => {
                                return <td key={index}>{agendado ? agendado : 0}</td>
                            })
                            :
                            printZeroCells()
                        }
                    </tr>
                </tbody>
            </Table>
            <label className="ml-1 mr-0 w-50">Capacidade: Capacidade máxima de atendimento do Gate.</label><br />
            <label className="ml-1 mr-0 w-50">Atendidos: Total de veículos já atendidos pelo Gate.</label><br />
            <label className="ml-1 mr-0 w-50">Agendados: Total de veículos agendados por todas as Transportadoras.</label><br /><br />
        </div>
    );
}

export const ListaMember = (props) => {
    return (
        isLogado() &&
        <div className="filtros">
            <Table responsive hover striped bordered>

                <thead className="destaque">
                    <tr>
                        <td colSpan="25"><b>{props.tipoFaina}</b></td>
                    </tr>
                    <tr>
                        <th></th>
                        {printHeadersHours()}
                    </tr>
                </thead>
                <tbody className="destaque">
                    <tr>
                        <th scope="row">Agendados</th>
                        {props.lista && props.lista.agendados && props.lista.agendados.length > 0 ?
                            props.lista.agendados.map((agendado, index) => {
                                return <td key={index}>{agendado ? agendado : 0}</td>
                            })
                            :
                            printZeroCells()
                        }
                    </tr>
                    <tr>
                        <th scope="row">Gate</th>
                        {props.lista && props.lista.gateExpresso && props.lista.gateExpresso.length > 0 ?
                            props.lista.gateExpresso.map((gateExpresso, index) => {
                                return <td key={index}>{gateExpresso ? gateExpresso : 0}</td>
                            })
                            :
                            printZeroCells()
                        }
                    </tr>
                </tbody>
            </Table>
            <label className="ml-1 mr-0 w-50">Agendados: Total de veículos agendados por você.</label><br />
            <label className="ml-1 mr-0 w-50">Gate: Total de veículos agendados já atendidos pelo Gate.</label><br /><br />
        </div>
    );
}

export const ListaNoShow = (props) => {
    return (
        isLogado() &&
        <div className="filtros">
            <Table responsive hover striped bordered>

                <thead className="destaque">
                    <tr>
                        <td colSpan="25"><b>{props.tipoFaina}</b></td>
                    </tr>
                    <tr>
                        <th></th>
                        {printHeadersHours()}
                    </tr>
                </thead>
                <tbody className="destaque">
                    <tr>
                        <th scope="row">Vencidos</th>
                        {props.lista && props.lista.perdidos && props.lista.perdidos.length > 0 ?
                            props.lista.perdidos.map((perdido, index) => {
                                return <td key={index}>{perdido ? perdido : 0}</td>
                            })
                            :
                            printZeroCells()
                        }
                    </tr>
                </tbody>
            </Table>
        </div>
    );
}

export const ListaInfo = (props) => {
    return (
        <div className="filtros">
            <Table responsive hover striped bordered>

                <thead className="destaque">
                    <tr>
                        <td colSpan="25"><b>{props.tipoFaina}</b></td>
                    </tr>
                    <tr>
                        <th>Descrição</th>
                        <th>Valor</th>
                    </tr>
                </thead>
                <tbody className="destaque">
                    {props.lista && props.lista.map((dados, index) => {
                        return <tr key={index}>
                            <td width="50%">{dados.Tipo}</td>
                            <td width="50%" style={{ textAlign: "right" }}>{dados.Info}</td>
                        </tr>
                    })
                    }
                </tbody>
            </Table>
        </div>
    );
}




// WEBPACK FOOTER //
// ./src/modules/agendamento/dashboard/componentes/TabelaDashboardGeral.js